export const getPriceModelForPermission = /* GraphQL */ `
  query GetPriceModelForPermission($featureId: String, $itemAmount: Int, $level: String) {
    getPriceModelForPermission(featureId: $featureId, itemAmount: $itemAmount, level: $level) {
      id
      name
      price
      price1Y
    }
  }
`
